import { FormEvent } from "react";
import { TranslationKey } from "../../../shared/i18n/i18n";
import { TwoFactorMethod } from "../../types/admin";

type TwoFactorChallengeViewProps = {
  code: string;
  isSubmitting: boolean;
  method: null | TwoFactorMethod;
  onCodeChange: (value: string) => void;
  onSubmit: (event: FormEvent) => Promise<void>;
  t: (key: TranslationKey) => string;
};

export const TwoFactorChallengeView = ({ code, isSubmitting, method, onCodeChange, onSubmit, t }: TwoFactorChallengeViewProps) => (
  <form className="auth-form" onSubmit={(event) => void onSubmit(event)}>
    <p className="admin-subtitle">
      {method === "EMAIL" ? t("admin.twoFactor.emailPrompt") : t("admin.twoFactor.authenticatorPrompt")}
    </p>
    <label className="field">
      <span>{t("admin.twoFactor.code")}</span>
      <input
        autoComplete="one-time-code"
        inputMode="numeric"
        onChange={(event) => onCodeChange(event.target.value)}
        required
        value={code}
      />
    </label>
    <button className="primary-button" disabled={isSubmitting} type="submit">
      {isSubmitting ? t("admin.button.verifying") : t("admin.twoFactor.verify")}
    </button>
  </form>
);
